import { createIcon } from '../../core/utils/uni-icon.js';
import type { DataViewUILogicBaseConstructor } from '../../core/view/data-view-base.js';
import { ganttViewModel } from './define.js';
import { GanttViewUILogic } from './pc/gantt-view-ui-logic.js';

/**
 * The framework's `pcLogic` signature returns the unparameterised
 * `DataViewUILogicBaseConstructor`. Our concrete `GanttViewUILogic`
 * parameterises the base generics (`GanttSingleView`, selection type) —
 * structurally compatible, but TypeScript can't prove it through the
 * invariant `Constructor<typeof ...>` helper. The cast below narrows
 * our constructor to the shape the renderer registry expects; it is
 * intentionally explicit rather than relying on `@ts-expect-error`.
 */
const ganttPcLogic =
  GanttViewUILogic as unknown as DataViewUILogicBaseConstructor;

export const ganttViewMeta = ganttViewModel.createMeta({
  icon: createIcon('TimelineIcon'),
  pcLogic: () => ganttPcLogic,
});
